import React from "react";
import PropTypes from "prop-types";
import styles from "./CardItem.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { getCardBrandIcon } from "../../utils/cardBrandIcon";

const CardItem = ({ cardInfo, isSelected, onSelect }) => {
  const { t } = useTranslation();

  const { nickName, lastFour, expireYear, expireMonth, cardType } = cardInfo;

  const handleSelect = () => {
    onSelect(cardInfo);
    // window.alert(isSelected ? "Checked" : "Selected");
  };

  return (
    <div className={styles.cardItem} onClick={handleSelect}>
      <div className="container">
        <div className={styles.cardInfo}>
          <FontAwesomeIcon
            icon={getCardBrandIcon(cardType)}
            className={styles.cardBrandIcon}
            title={cardType ?? "Card"}
          />
          <div className={styles.infoContainer}>
            <div>
              {t("Ending in")} {lastFour}
            </div>
            <div>
              Exp: {expireMonth}/{expireYear}
            </div>
          </div>
          <div className={styles.nickName}>{nickName}</div>
        </div>
      </div>
    </div>
  );
};

CardItem.propTypes = {
  cardInfo: PropTypes.shape({
    zipCode: PropTypes.string,
    cardType: PropTypes.string,
    nickName: PropTypes.string.isRequired,
    lastFour: PropTypes.string.isRequired,
    expireYear: PropTypes.string.isRequired,
    expireMonth: PropTypes.string.isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default CardItem;
